module.exports = __WEBPACK_EXTERNAL_MODULE_7__;


//////////////////
// WEBPACK FOOTER
// external {"amd":"openfl/errors/ArgumentError","root":["openfl","errors","ArgumentError"],"commonjs":"openfl/errors/ArgumentError","commonjs2":"openfl/errors/ArgumentError"}
// module id = 7
// module chunks = 0